"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.SidebarSection = void 0;
const lit_1 = require("lit");
const decorators_js_1 = require("lit/decorators.js");
const if_defined_js_1 = require("lit/directives/if-defined.js");
require("@/components/common/list-item/list-item");
require("@/components/common/list-item/list-item-group");
const list_item_styles_1 = require("@/components/common/list-item/list-item.styles");
const disclosure_controller_1 = require("@/controllers/disclosure-controller");
const shared_styles_1 = require("@/stylesheets/shared.styles");
const utils_1 = require("@/utils");
require("@/components/indicators/expand-indicator/expand-indicator");
/**
 * 사이드바에서 하위 페이지 링크를 접었다 펴는 섹션.
 * 명령이 아니라 탐색이므로 menu가 아닌 list로 읽히고, 열림 상태는 DisclosureController가 소유한다.
 */
let SidebarSection = class SidebarSection extends lit_1.LitElement {
    constructor() {
        super(...arguments);
        this.label = '';
        this.open = false;
        this.panelId = (0, utils_1.uniqueId)('sidebar-section-panel');
        this.disclosure = new disclosure_controller_1.DisclosureController(this, {
            isOpen: () => this.open,
            setOpen: open => {
                this.open = open;
            },
            getTrigger: () => this.trigger ?? undefined,
        });
    }
    render() {
        return (0, lit_1.html) `
      <button type="button" aria-controls=${this.panelId}>
        <mm-list-item avatar-variant="tertiary" label=${this.label} icon=${(0, if_defined_js_1.ifDefined)(this.icon)}>
          <mm-expand-indicator slot="trailing" ?expanded=${this.open}></mm-expand-indicator>
        </mm-list-item>
      </button>

      <div id=${this.panelId} class="panel" ?inert=${!this.open}>
        <mm-list-item-group gap="0"><slot></slot></mm-list-item-group>
      </div>
    `;
    }
};
SidebarSection.styles = [
    shared_styles_1.resetStyles,
    list_item_styles_1.interactiveRowStyles,
    (0, lit_1.css) `
      :host {
        display: block;
      }

      /* grid trick: 0fr → 1fr 로 패널 높이를 접는다 */
      .panel {
        display: grid;
        grid-template-rows: 0fr;
      }

      mm-list-item-group {
        overflow: hidden;
      }

      :host([open]) .panel {
        grid-template-rows: 1fr;
      }

      /* 트리거와 하위 링크 간격. 닫힐 때 패널이 완전히 접히도록 열림 상태에서만 준다 */
      :host([open]) mm-list-item-group {
        padding-top: var(--space-1);
      }
    `,
];
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarSection.prototype, "label", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: String })
], SidebarSection.prototype, "icon", void 0);
__decorate([
    (0, decorators_js_1.property)({ type: Boolean, reflect: true })
], SidebarSection.prototype, "open", void 0);
__decorate([
    (0, decorators_js_1.query)('button')
], SidebarSection.prototype, "trigger", void 0);
SidebarSection = __decorate([
    (0, decorators_js_1.customElement)('mm-sidebar-section')
], SidebarSection);
exports.SidebarSection = SidebarSection;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoic2lkZWJhci1zZWN0aW9uLmpzIiwic291cmNlUm9vdCI6IiIsInNvdXJjZXMiOlsic2lkZWJhci1zZWN0aW9uLnRzIl0sIm5hbWVzIjpbXSwibWFwcGluZ3MiOiI7Ozs7Ozs7OztBQUFBLDZCQUEyQztBQUMzQyxxREFBa0U7QUFDbEUsZ0VBQXdEO0FBSXhELG1EQUFnRDtBQUNoRCx5REFBc0Q7QUFDdEQscUZBQXFGO0FBQ3JGLCtFQUEwRTtBQUMxRSwrREFBeUQ7QUFDekQsbUNBQWtDO0FBQ2xDLHFFQUFrRTtBQUVsRTs7O0dBR0c7QUFFSSxJQUFNLGNBQWMsR0FBcEIsTUFBTSxjQUFlLFNBQVEsZ0JBQVU7SUFBdkM7O1FBNkJ1QixVQUFLLEdBQUcsRUFBRSxDQUFBO1FBRU0sU0FBSSxHQUFHLEtBQUssQ0FBQTtRQUV2QyxZQUFPLEdBQUcsSUFBQSxnQkFBUSxFQUFDLHVCQUF1QixDQUFDLENBQUE7UUFDcEQsZUFBVSxHQUFHLElBQUksNENBQW9CLENBQUMsSUFBSSxFQUFFO1lBQ2xELE1BQU0sRUFBRSxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsSUFBSTtZQUN2QixPQUFPLEVBQUUsSUFBSSxDQUFDLEVBQUU7Z0JBQ2QsSUFBSSxDQUFDLElBQUksR0FBRyxJQUFJLENBQUE7WUFDbEIsQ0FBQztZQUNELFVBQVUsRUFBRSxHQUFHLEVBQUUsQ0FBQyxJQUFJLENBQUMsT0FBTyxJQUFJLFNBQVM7U0FDNUMsQ0FBQyxDQUFBO0lBZUosQ0FBQztJQWJDLE1BQU07UUFDSixPQUFPLElBQUEsVUFBSSxFQUFBOzRDQUM2QixJQUFJLENBQUMsT0FBTzt3REFDQSxJQUFJLENBQUMsS0FBSyxTQUFTLElBQUEseUJBQVMsRUFBQyxJQUFJLENBQUMsSUFBSSxDQUFDOzJEQUNwQyxJQUFJLENBQUMsSUFBSTs7OztnQkFJcEQsSUFBSSxDQUFDLE9BQU8seUJBQXlCLENBQUMsSUFBSSxDQUFDLElBQUk7OztLQUcxRCxDQUFBO0lBQ0gsQ0FBQzs7QUFyRE0scUJBQU0sR0FBRztJQUNkLDJCQUFXO0lBQ1gsdUNBQW9CO0lBQ3BCLElBQUEsU0FBRyxFQUFBOzs7Ozs7Ozs7Ozs7Ozs7Ozs7Ozs7OztLQXVCRjtDQUNGLENBQUE7QUFDMkI7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzZDQUFXO0FBQ1Y7SUFBM0IsSUFBQSx3QkFBUSxFQUFDLEVBQUUsSUFBSSxFQUFFLE1BQU0sRUFBRSxDQUFDOzRDQUFnQjtBQUNDO0lBQTNDLElBQUEsd0JBQVEsRUFBQyxFQUFFLElBQUksRUFBRSxPQUFPLEVBQUUsT0FBTyxFQUFFLElBQUksRUFBRSxDQUFDOzRDQUFhO0FBQ3ZDO0lBQWhCLElBQUEscUJBQUssRUFBQyxRQUFRLENBQUM7K0NBQThCO0FBaENuQyxjQUFjO0lBRDFCLElBQUEsNkJBQWEsRUFBQyxvQkFBb0IsQ0FBQztHQUN2QixjQUFjLENBdUQxQjtBQXZEWSx3Q0FBYyJ9